// market — am. Part of the am i18n bundle; merged by ./index.js

export default {
  loading: 'በመጫን ላይ...',
  marketTitle: 'ገበያ',
  marketSubtitle: 'ከፈቃድ ያላቸው ሻሪካታታች የሚቀሩ ሁሉም ምርቶች — ሁል ጊዜ ክፍት ነው፣ መጠበቅም የለም።',
  bestDealToday: '⚡ የዛሬ እጅግ ጥሩ ቅናሽ',
  bestDealsWeek: '🏆 የሳምንቱ እጅግ ጥሩ ቅናሾት',
  endsIn: 'ያበቃል',
// Bazaar & Market filter UI
  clearAll: 'ሁሉንም አጽዳ',
  searchLabel: 'ፈልግ',
  availability: 'ዝግጁነት',
  inStockOnly: 'በክምት ያለበት ብቻ',
  allLocations: 'ሁሉም አካባቢዎች',
  sellers: 'ሻሪካቶች',
  allSellers: 'ሁሉም ሻሪካቶች',
  applyFilters: 'ማጣሪያዎችን ተግብር',
  sortDefault: 'ደረጃ፡ መሠረታዊ',
  sortNewest: 'አዳዲስቱ ቀድሞ',
  sortPriceAsc: 'ዋጋ፡ ዝቅተኛ → ከፍተኛ',
  sortPriceDesc: 'ዋጋ፡ ከፍተኛ → ዝቅተኛ',
  sortNameAsc: 'ስም፡ አ → ዜ',
  statProducts: 'ምርቶች',
  statCategories: 'ምድቦች',
  statCities: 'ከተሞች',
  subcategoriesLabel: 'ንዑስ ምድቦች፦',
  all: 'ሁሉም',
  resultsNone: 'ከአሁኑ ማጣሪያዎች ጋር የሚዛመድ ምርት የለም',
  resultsCount: (n) => `${n} ምርቶች`,
  resultsCountOf: (a, b) => `ከ${b} ምርቶች ውስጥ ${a}`,
  priceUnder: (a) => `ከ${a} ብር በታች`,
  priceBand: (a, b) => `${a} – ${b} ብር`,
  priceOver: (a) => `ከ${a} ብር በላይ`,
  gridView: 'የመስክ እይታ',
  listView: 'የዝርዝር እይታ',
  scrollCatLeft: 'ምድቦችን ወደ ግራ ያንሸሳል',
  scrollCatRight: 'ምድቦችን ወደ ቀኝ ያንሸሳል',
  marketPlaceWord: 'ቦታ',
  marketTagline: 'በአንድ ቦታ የሚገኙ የተፈቀዱ ሁሉም ምርቶች — በምድብ ወይም በአካባቢ ያጣሩ።',
  comingSoon: 'በቅርብ የሚመጣ',
  openNow: 'ክፍት',
  closedNow: 'ዝጋ',
// Bazaar open/closed + countdown
  opensIn: '⏳ በዚህ ይከፍታል',
  closesIn: '· በዚህ ይዘጋል',
  nextBazaar: 'ቀጣዩ ባዘር',
  closedPromoTitle: 'የሚጠብቅዎት ይህ ነው',
  closedPromoDesc: 'ባዘሩ የሚያቀርባውን ይመልከቱ — ከመላው ኢትዮጵያ የተወሰዱ ምርቶች፣ ሻሪካቶች፣ ምድቦች እና ከተሞች።',
  scheduledByAdmin: 'በአስተዳዳሪው ተቀምጧል',
  bazaarClosedBadge: 'ባዘሩ ተዝግቷል',
  closedReminder: 'አስታውሰኝ',
  closedReminderDesc: 'የ All Things ባዘር እንደገና ይከፈታል — ቅናሾቹ ከመጥፋታቸው በፊት ይምጡ!',
  closedWhyTitle: 'ባዘሩን ለምን ይወዱታል',
  closedWhyDesc: 'በባዘር ቀን ሙሉ ገበያ ይከፈታል — ለመጠበቅ የሚገባው ምክንያት ይህ ነው።',
  closedFeature1Title: 'የባዘር ብቻ ቅናሾች',
  closedFeature1Desc: 'ባዘሩ በሚከፈትበት ጊዜ ብቻ የሚገኙ ልዩ ቅናሾች።',
  closedFeature2Title: 'የተረጋገጡ ሻሪካቶች',
  closedFeature2Desc: 'ከታመኑና ከፀደቁ የኢትዮጵያ ንግዶች ይግዙ።',
  closedFeature3Title: 'ትዕዛዝ እና ማድረስ',
  closedFeature3Desc: 'ይግዙ እና ማድረሱን ከመድረኩ ላይ ያስተባብሩ።',
  closedFeature4Title: 'በቀጥታ ይወያዩ',
  closedFeature4Desc: 'ከመግዛትዎ በፊት ሻሪካቶችን ያግኙ።',
  closedCatsTitle: 'ምን ማግኘት ይችላሉ',
  lastUpdated: 'መጨረሻ ማሻሻያ',
  mpCatGridTitle: 'በምድብ ይሞክሩ',
  mpCatGridViewAll: 'ሁሉንም ይመልከቱ',
  signInToAdd: 'ወደ የምስጥራት ዝርዝርዎ ለመጨመር እባክዎ ይግቡ።',
  signInRequired: 'መግባት ያስፈልጋል',
  wishlistLoginDesc: 'ወደ የምስጥራት ዝርዝርዎ ለመጨመርና ሙያና እንዳደርግ መግባት ያስፈልግዎታል።',
  cancel: 'ሰርዝ',
  soldOut: 'ተጣልቷል',
  bundle: 'ጥቅል',
  addedToWishlist: (name) => `❤️ ${name} ወደ የምስጥራት ዝርዝር ተጨምሯል!`,
  searchProducts: 'ምርቶችን ፈልግ...',
  noResults: 'ምርቶች አልተገኙም።',
};
